module.exports = function createForm(save) {
 return { pending:false, saved:false, errors:{}, message:'', async submit(draft) {
  if(this.pending) return;
  this.pending=true; this.saved=false; this.errors={}; this.message='';
  try { await save(draft); this.saved=true; }
  catch(error) { const response=error.response; this.errors=response && response.data && response.data.errors || {}; this.message=response && response.status===401 ? 'Your session has expired. Log in to continue.' : response && response.status===403 ? 'Security token expired. Reload this page and try again.' : Object.keys(this.errors).length ? 'Please correct the fields below.' : 'Unable to save. Please try again.'; }
  finally {this.pending=false;}
 }};
};
